<template>
  <basic-dialog :show="show" @close="$emit('close')">
    <template v-slot:title>{{ title }}</template>
    <v-tabs
      background-color="deep-purple accent-4"
      center-active
      dark
      v-model="tab"
    >
      <v-tab key="details">Details</v-tab>
      <v-tab key="documents">Documents</v-tab>
      <v-tab key="customFields">Custom Fields</v-tab>
      <v-tab key="accessSettings">Access Settings</v-tab>
      <v-tab key="contents">Contents</v-tab>
      <v-tab key="linksApi">LINKS API</v-tab>

      <v-tabs-items v-model="tab">

        <v-tab-item key="details">
          <v-row>
            <v-col>
              <v-text-field
                type="text"
                label="Name"
                v-model="name"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                type="number"
                label="Max Users"
                v-model="maxUsers"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                label="Notes"
                v-model="notes"
                :outlined="outlinedInputs"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item key="documents">
          <owner-documents v-model="value"></owner-documents>
        </v-tab-item>
        <v-tab-item key="customFields">
          <owner-custom-fields v-model="value"></owner-custom-fields>
        </v-tab-item>
        <v-tab-item key="accessSettings">
          <access-settings-editor
            v-if="value"
            v-model="value.accessSettings"
          ></access-settings-editor>
        </v-tab-item>
        <v-tab-item key="contents">
          <template v-if="id != ''">
            <contents owner-name="OWNER" :owner-id="id" />
          </template>
        </v-tab-item>
        <v-tab-item key="linksApi">
          <v-row>
            <v-col>
              <v-text-field
                type="text"
                label="API Url"
                v-model="apiUrl"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                type="text"
                label="Tenant Code"
                v-model="tenantCode"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <template v-slot:actions>
      <v-btn
        v-if="tab == 0 || tab == 3"
        color="primary"
        @click="onSave"
        :disabled="!isValid"
        >Save</v-btn
      >
    </template>
    <div v-if="debug">
      <code>{{ value }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import AccessSettingsEditor from "../../agents/AccessSettingsEditor.vue";
import BasicDialog from "../../shared/BasicDialog.vue";
import OwnerCustomFields from "./OwnerCustomFields.vue";
import OwnerDocuments from "./OwnerDocuments.vue";
import Contents from "../../shared/contents/Contents";
const UPDATE_OWNER = gql`
  mutation updateOwner($input: OwnerInput) {
    updateOwner(input: $input) {
      id
      domain
      maxUsers
      name
      notes
      apiUrl
      tenantCode
      accessSettings {
        groupName
        settingName
        settingValue
      }
    }
  }
`;
export default {
  name: "owner-details-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    OwnerDocuments,
    OwnerCustomFields,
    AccessSettingsEditor,
    Contents,
  },

  data() {
    return {
      debug: false,
      tab: null,
      maxUsers: this.value ? this.value.maxUsers : 0,
      id: this.value && this.value.id ? this.value.id : "",
      name: this.value ? this.value.name : "",
      notes: this.value ? this.value.notes : "",
      tenantCode: this.value ? this.value.tenantCode : "",
      apiUrl: this.value ? this.value.apiUrl : "",
    };
  },

  computed: {
    title() {
      return this.name != "" ? `${this.name}` : "Owner Details";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "";
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.notes = newVal.notes;
      this.maxUsers = newVal.maxUsers;
      this.tenantCode = newVal.tenantCode;
      this.apiUrl = newVal.apiUrl;
      if (newVal.id) {
        this.id = newVal.id;
      } else {
        this.id = "";
      }
    },
  },

  methods: {
    onSave() {
      const input = {
        id: this.value.id,
        name: this.name,
        maxUsers: Number(this.maxUsers),
        notes: this.notes,
        apiUrl: this.apiUrl,
        tenantCode: this.tenantCode,
        accessSettings: [
          ...this.value.accessSettings.map((item) => ({
            groupName: item.groupName,
            settingName: item.settingName,
            settingValue: item.settingValue,
          })),
        ],
      };

      this.$apollo
        .mutate({
          mutation: UPDATE_OWNER,
          variables: { input },
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Changes saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/user-access-controls/OwnerDetailsDialog.vue